import { render, staticRenderFns } from "./LogoPlacementComponent.vue?vue&type=template&id=0bcef178&scoped=true&"
import script from "./LogoPlacementComponent.vue?vue&type=script&lang=ts&"
export * from "./LogoPlacementComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LogoPlacementComponent.vue?vue&type=style&index=0&id=0bcef178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcef178",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VCombobox,VIcon})
